"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetNextBestPropositionRequest = void 0;
const tslib_1 = require("tslib");
const GetNextBestBase_1 = tslib_1.__importDefault(require("../GetNextBestBase"));
const class_validator_1 = require("class-validator");
const class_transformer_1 = require("class-transformer");
const base_models_1 = require("@integration/base-models");
class GetNextBestPropositionRequest extends GetNextBestBase_1.default {
}
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsNumber)({ maxDecimalPlaces: 0 }),
    (0, class_validator_1.Min)(1),
    (0, class_validator_1.Max)(100),
    (0, class_transformer_1.Type)(() => Number),
    (0, class_transformer_1.Expose)({ name: 'max_propositions' }),
    (0, base_models_1.Docs)({
        example: 2,
        description: `The max number of propositions that should be returned.
Due to our offer feedback rule engine, we can not promise a minimum number of propositions to be returned.`,
    }),
    tslib_1.__metadata("design:type", Number)
], GetNextBestPropositionRequest.prototype, "maxPropositions", void 0);
exports.GetNextBestPropositionRequest = GetNextBestPropositionRequest;
